import React, { useState } from 'react'
import "./CandidateProfile.css";
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

function RecruitmentCandidateProfile() {
  const [activeTab, setActiveTab] = useState("overview");

  const [editModal, setEditModal] = useState(false);
  const [addNoteModal, setAddNoteModal] = useState(false);
  const [feedbackModal, setFeedbackModal] = useState(false);
  const [createEmpModal, setCreateEmpModal] = useState(false);

  const toast = (msg, type = "success") => {
    const t = document.createElement("div");
    t.className = "og-toast";
    const color =
      type === "warn" ? "#fbbf24" : type === "error" ? "#f87171" : "#4ade80";
    const icon =
      type === "warn"
        ? "fa-triangle-exclamation"
        : type === "error"
          ? "fa-times-circle"
          : "fa-check-circle";
    t.innerHTML = `<i class="fa-solid ${icon}" style="color:${color};"></i>${msg}`;
    document.body.appendChild(t);
    setTimeout(() => {
      t.style.opacity = "0";
      setTimeout(() => t.remove(), 300);
    }, 2800);
  };

  return (
    <>
    <div className="topbar">

        <i className="fa-solid fa-user-tie"></i>
        <div className="breadcrumb topbar-breadcrumb">

          <a href="#">Candidates
</a>
          <i className="fa-solid fa-chevron-right topbar-chevron"></i>
          <strong className="topbar-current"> Rahul Kumar </strong>
        </div>
        <div className="top-right">

          <div className="top-user">

            <div className="top-avatar">AM</div>
            <div>

              <div className="top-user-name"> Arun Mishra </div>
              <div className="top-user-role"> HR Admin </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid position-relation">
          <div className="candidate-action-bar">

  <div className="breadcrumb candidate-action-breadcrumb">
    <Link to="/Recruitment/Reimbursement-Dadhboard"  className="btn btn-outline btn-sm btn-gray">
      <i className="fa-solid fa-arrow-left candidate-back-icon"></i>
      Back 
    </Link>
  </div>

  <div className="candidate-actions">

    <button
      className="btn btn-outline btn-sm"
      onClick={() => setEditModal(true)}
    >
      <i className="fa-solid fa-pen"></i> Edit
    </button>

    <Link to="/Recruitment/RecruitmentLinkCandidate"
      className="btn btn-outline btn-sm"
      
    >
      <i className="fa-solid fa-link"></i> Link to Job
    </Link>

    <Link to="/Recruitment/ScheduleInterview"
      className="btn btn-outline btn-sm btn-gray"
      
    >
      <i className="fa-solid fa-calendar-plus"></i> Schedule Interview
    </Link>

    <button
      className="btn btn-warn btn-sm btn-gray"
      onClick={() => setFeedbackModal(true)}
    >
      <i className="fa-solid fa-star"></i> Add Feedback
    </button>

    <button
      className="btn btn-primary btn-sm"
      onClick={() => setCreateEmpModal(true)}
    >
      <i className="fa-solid fa-user-check"></i> Create Employee
    </button>

  </div>
</div>

<div className="profile-layout">

  {/* =========================
      SIDEBAR
  ========================= */}
  <div className="profile-sidebar">

    <div className="profile-card">

      <div className="pc-header">
        <div className="pc-av">RK</div>

        <div className="pc-name">
          Rahul Kumar
        </div>

        <div className="pc-role">
          Senior Frontend Developer · 5 yrs
        </div>

        <div className="pc-stage">
          <span className="pc-stage-badge text-white">
            Interview — Round 2
          </span>
        </div>
      </div>

      <div className="pc-body">

        <div className="pc-row">
          <i className="fa-solid fa-envelope"></i>
          <div>
            <div className="pc-label">Email</div>
            <div className="pc-value">
              rahul.kumar@gmail.com
            </div>
          </div>
        </div>

        <div className="pc-row">
          <i className="fa-solid fa-phone"></i>
          <div>
            <div className="pc-label">Phone</div>
            <div className="pc-value">
              +91 99001 23456
            </div>
          </div>
        </div>

        <div className="pc-row">
          <i className="fa-solid fa-location-dot"></i>
          <div>
            <div className="pc-label">Location</div>
            <div className="pc-value">
              Delhi, India
            </div>
          </div>
        </div>

        <div className="pc-row">
          <i className="fa-solid fa-briefcase"></i>
          <div>
            <div className="pc-label">Experience</div>
            <div className="pc-value">5 years</div>
          </div>
        </div>

        <div className="pc-row">
          <i className="fa-solid fa-indian-rupee-sign"></i>
          <div>
            <div className="pc-label">Expected CTC</div>
            <div className="pc-value">14–18 LPA</div>
          </div>
        </div>

        <div className="pc-row">
          <i className="fa-solid fa-user-clock"></i>
          <div>
            <div className="pc-label">Notice Period</div>
            <div className="pc-value">30 days</div>
          </div>
        </div>

        <div className="pc-row">
          <i className="fa-solid fa-house-laptop"></i>
          <div>
            <div className="pc-label">Preference</div>
            <div className="pc-value">Remote / Hybrid</div>
          </div>
        </div>

        <div className="pc-sec">
          Candidate Source
        </div>

        <span className="source-badge src-ats">
          ATS — Direct Apply
        </span>

        <div className="pc-sec">
          Added By
        </div>

        <div className="pc-added-date">
          Auto · Jun 3, 2026
        </div>

        <div className="pc-sec">
          Resume
        </div>

        <button
          className="btn btn-outline btn-sm resume-btn"
          onClick={() => toast("Downloading resume…")}
        >
          <i className="fa-solid fa-download"></i>
          Download Resume
        </button>

        <div className="quick-links-box">
          <div className="pc-sec">
            Quick Links
          </div>

          <div className="quick-links">
            <button className="btn btn-outline btn-xs">
              <i className="fa-brands fa-linkedin"></i>
            </button>

            <button className="btn btn-outline btn-xs">
              <i className="fa-brands fa-github"></i>
            </button>

            <button
              className="btn btn-outline btn-xs"
              onClick={() => toast("Portfolio opened")}
            >
              <i className="fa-solid fa-globe"></i>
            </button>
          </div>
        </div>

      </div>
    </div>

    {/* =========================
        CURRENT JOB STATUS
    ========================= */}
    <div className="profile-card">

      <div className="job-status-header">
        <div className="job-status-title">
          Current Job Status
        </div>
      </div>

      <div className="job-status-body">

        <div className="job-status-row">
          <span className="job-status-label">Job</span>
          <span className="job-status-value job-status-job">
            JOB-2026-001
          </span>
        </div>

        <div className="job-status-row">
          <span className="job-status-label">Stage</span>
          <span className="job-status-value job-status-stage">
            Interview
          </span>
        </div>

        <div className="job-status-row">
          <span className="job-status-label">Round</span>
          <span className="job-status-value">
            R2 — HR Interview
          </span>
        </div>

        <div className="job-status-row">
          <span className="job-status-label">Interview</span>
          <span className="job-status-value job-status-interview">
            Today 11 AM
          </span>
        </div>

        <div className="job-status-row">
          <span className="job-status-label">Recruiter</span>
          <span className="job-status-value">
            Priya Sharma
          </span>
        </div>

        <button
          className="btn btn-primary btn-xs pipeline-btn"
          onClick={() => {
            window.location.href = "recruitment-job-detail.html";
          }}
        >
          View in Pipeline
        </button>

      </div>
    </div>

  </div>


  {/* =========================
      RIGHT CONTENT
  ========================= */}
  <div>

    {/* TAB BAR */}
    <div className="tab-bar">

      <button
        className={`tab-btn ${activeTab === "overview" ? "active" : ""}`}
        onClick={() => setActiveTab("overview")}
      >
        <i className="fa-solid fa-house"></i>
        Overview
      </button>

      <button
        className={`tab-btn ${activeTab === "applications" ? "active" : ""}`}
        onClick={() => setActiveTab("applications")}
      >
        <i className="fa-solid fa-briefcase"></i>
        Applications
        <span className="tab-count">2</span>
      </button>

      <button
        className={`tab-btn ${activeTab === "interviews" ? "active" : ""}`}
        onClick={() => setActiveTab("interviews")}
      >
        <i className="fa-solid fa-calendar-check"></i>
        Interviews
        <span className="tab-count">3</span>
      </button>

    </div>


    {/* =========================
        OVERVIEW TAB
    ========================= */}
    <div id="tab-overview" className={activeTab === "overview" ? "" : "tab-hidden"}>

      {/* QUICK STATS */}
      <div className="quick-stats">

        <div className="qs">
          <div className="qs-val qs-val-primary">2</div>
          <div className="qs-lbl">Jobs Applied</div>
        </div>

        <div className="qs">
          <div className="qs-val qs-val-amber">3</div>
          <div className="qs-lbl">Interview Rounds</div>
        </div>

        <div className="qs">
          <div className="qs-val qs-val-green">2</div>
          <div className="qs-lbl">Rounds Cleared</div>
        </div>

        <div className="qs">
          <div className="qs-val qs-val-blue">23</div>
          <div className="qs-lbl">Days in System</div>
        </div>

      </div>


      {/* PERSONAL & CONTACT */}
      <div className="sec-block">

        <div className="sec-hd">
          <h4>
            <i className="fa-solid fa-user sec-heading-icon"></i>
            Personal &amp; Contact
          </h4>

          <button
            className="btn-ghost btn-xs"
            onClick={() => setEditModal(true)}
          >
            <i className="fa-solid fa-pen"></i>
            Edit
          </button>
        </div>

        <div className="info-grid">

          <div className="info-item">
            <div className="info-label">Full Name</div>
            <div className="info-value">Rahul Kumar</div>
          </div>

          <div className="info-item">
            <div className="info-label">Current Role</div>
            <div className="info-value">
              Senior Frontend Developer
            </div>
          </div>

          <div className="info-item">
            <div className="info-label">Email</div>
            <div className="info-value">
              rahul.kumar@gmail.com
            </div>
          </div>

          <div className="info-item">
            <div className="info-label">Phone</div>
            <div className="info-value">
              +91 99001 23456
            </div>
          </div>

          <div className="info-item">
            <div className="info-label">Location</div>
            <div className="info-value">Delhi, India</div>
          </div>

          <div className="info-item">
            <div className="info-label">Work Mode</div>
            <div className="info-value">Remote / Hybrid</div>
          </div>

          <div className="info-item">
            <div className="info-label">Expected CTC</div>
            <div className="info-value">14–18 LPA</div>
          </div>

          <div className="info-item">
            <div className="info-label">Notice Period</div>
            <div className="info-value">30 days</div>
          </div>

          <div className="info-item">
            <div className="info-label">Total Experience</div>
            <div className="info-value">5 years</div>
          </div>

          <div className="info-item">
            <div className="info-label">Current Company</div>
            <div className="info-value">
              OrgGenie Technologies
            </div>
          </div>

        </div>

        <div className="info-about">

          <div className="info-label about-label">
            About
          </div>

          <div className="about-text">
            Senior Frontend Developer with 5 years of experience
            in React and TypeScript. Passionate about clean code
            and design systems. Open source contributor. Mentored
            junior developers at previous company.
          </div>

        </div>

      </div>


      {/* SKILLS */}
      <div className="sec-block">

        <div className="sec-hd">
          <h4>
            <i className="fa-solid fa-tags sec-heading-icon"></i>
            Skills
          </h4>
        </div>

        <div>

          <div className="skill-group">
            Primary Skills
          </div>

          <span className="skill-chip">React</span>
          <span className="skill-chip">TypeScript</span>
          <span className="skill-chip">Next.js</span>
          <span className="skill-chip">Redux</span>
          <span className="skill-chip">CSS/SCSS</span>
          <span className="skill-chip">Webpack</span>
          <span className="skill-chip">Git</span>
          <span className="skill-chip">Jest</span>

        </div>

        <div className="secondary-skill-group">

          <div className="skill-group">
            Secondary Skills
          </div>

          <span className="skill-chip secondary-skill">
            Node.js
          </span>

          <span className="skill-chip secondary-skill">
            Figma
          </span>

          <span className="skill-chip secondary-skill">
            Storybook
          </span>

        </div>

      </div>


      {/* WORK EXPERIENCE */}
      <div className="sec-block">

        <div className="sec-hd">
          <h4>
            <i className="fa-solid fa-briefcase sec-heading-icon"></i>
            Work Experience
          </h4>
        </div>

        <div className="exp-item">

          <div className="exp-top">

            <div>
              <div className="exp-company">
                OrgGenie Technologies Pvt Ltd
              </div>

              <div className="exp-role">
                Senior Frontend Developer
              </div>

              <div className="exp-dates">
                Jan 2022 – Present · 2.5 yrs · Delhi
              </div>
            </div>

            <span className="exp-current">
              Current
            </span>

          </div>

          <div className="exp-description">
            Led dashboard migration from class components to
            hooks; improved load time 40%; built component library.
          </div>

        </div>


        <div className="exp-item">

          <div className="exp-company">
            StartupBase Inc
          </div>

          <div className="exp-role">
            Frontend Developer
          </div>

          <div className="exp-dates">
            Jun 2019 – Dec 2021 · 2.5 yrs · Bengaluru (Remote)
          </div>

          <div className="exp-description">
            Built e-commerce frontend from scratch, integrated
            payment gateways, React+Redux.
          </div>

        </div>

      </div>


      {/* EDUCATION */}
      <div className="sec-block">

        <div className="sec-hd">
          <h4>
            <i className="fa-solid fa-graduation-cap sec-heading-icon"></i>
            Education
          </h4>
        </div>

        <div className="exp-item education-item">

          <div className="exp-company">
            B.Tech — Computer Science
          </div>

          <div className="exp-role">
            Delhi Technological University
          </div>

          <div className="exp-dates">
            2015 – 2019 · 8.2 CGPA
          </div>

        </div>

      </div>


      {/* HR NOTES */}
      <div className="sec-block">

        <div className="sec-hd">

          <h4>
            <i className="fa-solid fa-note-sticky sec-heading-icon amber"></i>
            HR Notes
          </h4>

          <button
            className="btn btn-warn btn-xs"
            onClick={() => setAddNoteModal(true)}
          >
            <i className="fa-solid fa-plus"></i>
            Add Note
          </button>

        </div>


        <div className="note-item">

          <div className="note-text">
            Candidate showed excellent React knowledge. The live
            coding round went well — identified performance issues
            quickly. Strong communicator. Good cultural fit.
            Recommend proceeding to HR round.
          </div>

          <div className="note-meta">

            <span className="note-author">
              <div className="note-avatar note-avatar-rd">
                RD
              </div>
              Rahul Dev
            </span>

            <span>·</span>
            <span>R1 Technical Interview Panel</span>
            <span>·</span>
            <span>Jun 8, 2026 · 3d ago</span>

          </div>

        </div>


        <div className="note-item note-item-blue">

          <div className="note-text">
            Reached out proactively before the interview to
            confirm details. Very professional. LinkedIn profile
            is strong — recent project on GitHub shows real-world
            Next.js experience. Strong candidate.
          </div>

          <div className="note-meta">

            <span className="note-author">
              <div className="note-avatar note-avatar-ps">
                PS
              </div>
              Priya Sharma
            </span>

            <span>·</span>
            <span>HR</span>
            <span>·</span>
            <span>Jun 5, 2026 · 6d ago</span>

          </div>

        </div>


        <div className="notes-view-all">

          <button
            className="btn-ghost btn-xs"
            onClick={() => setActiveTab("interviews")}
          >
            View all notes in Interviews tab →
          </button>

        </div>

      </div>


      {/* ACTIVITY HISTORY */}
      <div className="sec-block">

        <div className="sec-hd">

          <h4>
            <i className="fa-solid fa-clock-rotate-left sec-heading-icon"></i>
            Activity History
          </h4>

          <span className="activity-last-events">
            Last 10 events
          </span>

        </div>


        <div className="tl-item">

          <div className="tl-dot tl-dot-amber">
            <i className="fa-solid fa-calendar tl-icon"></i>
          </div>

          <div className="tl-text">

            <strong>Round 2 scheduled</strong>
            {" "}— HR Interview on Jun 26, 11:00 AM. Panel:
            Priya Sharma. Mode: Google Meet.

            <div className="tl-time">
              Today 9:00 AM · Priya Sharma
            </div>

          </div>

        </div>


        <div className="tl-item">

          <div className="tl-dot tl-dot-green">
            <i className="fa-solid fa-check tl-icon"></i>
          </div>

          <div className="tl-text">

            <strong>Round 1 cleared</strong>
            {" "}— Technical Screening passed (Rating: 8.5/10).
            Stage moved to Interview.

            <div className="tl-time">
              Jun 8 4:30 PM · Rahul Dev
            </div>

          </div>

        </div>


        <div className="tl-item">

          <div className="tl-dot tl-dot-yellow">
            <i className="fa-solid fa-star tl-icon"></i>
          </div>

          <div className="tl-text">

            <strong>Feedback submitted</strong>
            {" "}— R1 Technical: Technical 8/10, Communication
            9/10, Problem Solving 8/10. Recommendation: Proceed.

            <div className="tl-time">
              Jun 8 3:45 PM · Rahul Dev
            </div>

          </div>

        </div>


        <div className="tl-item">

          <div className="tl-dot tl-dot-amber">
            <i className="fa-solid fa-calendar tl-icon"></i>
          </div>

          <div className="tl-text">

            <strong>Round 1 scheduled</strong>
            {" "}— Technical Screening on Jun 8, 10:00 AM.
            Panel: Rahul Dev. Mode: Zoom.

            <div className="tl-time">
              Jun 6 2:00 PM · Priya Sharma
            </div>

          </div>

        </div>


        <div className="tl-item">

          <div className="tl-dot tl-dot-indigo">
            <i className="fa-solid fa-arrow-right tl-icon"></i>
          </div>

          <div className="tl-text">

            <strong>Stage updated</strong>
            {" "}— Applied → Interview (after resume shortlisting
            by HR).

            <div className="tl-time">
              Jun 6 1:30 PM · Priya Sharma
            </div>

          </div>

        </div>


        <div className="tl-item">

          <div className="tl-dot tl-dot-primary">
            <i className="fa-solid fa-user-plus tl-icon"></i>
          </div>

          <div className="tl-text">

            <strong>Applied</strong>
            {" "}via ATS portal to Senior Frontend Developer
            (JOB-2026-001). CV auto-parsed.

            <div className="tl-time">
              Jun 3 11:22 AM · System
            </div>

          </div>

        </div>

      </div>

    </div>


    {/* =========================
        APPLICATIONS TAB
    ========================= */}
    <div id="tab-applications" className={activeTab === "applications" ? "" : "tab-hidden"}>

      <div className="sec-block">

        <div className="sec-hd">

          <h4>
            <i className="fa-solid fa-briefcase sec-heading-icon"></i>
            Job Applications
          </h4>

          <button
            className="btn btn-primary btn-xs"
            onClick={() => {
              window.location.href =
                "recruitment-link-candidate.html";
            }}
          >
            <i className="fa-solid fa-link"></i>
            Link to Job
          </button>

        </div>


        <div className="app-row">

          <div className="app-content">

            <div className="app-title">
              Senior Frontend Developer
            </div>

            <div className="app-meta">
              JOB-2026-001 · Engineering · Applied Jun 3, 2026
            </div>

          </div>

          <span className="stage-badge sb-interview">
            Interview — R2
          </span>

          <button
            className="btn btn-outline btn-xs"
            onClick={() => {
              window.location.href =
                "recruitment-job-detail.html";
            }}
          >
            <i className="fa-solid fa-pipe-section"></i>
            Pipeline
          </button>

        </div>


        <div className="app-row app-row-archived">

          <div className="app-content">

            <div className="app-title">
              Full Stack Developer
            </div>

            <div className="app-meta">
              JOB-2025-088 · Product · Mar 15, 2025 · Previous cycle
            </div>

          </div>

          <span className="stage-badge sb-rejected">
            Rejected — R1
          </span>

          <button
            className="btn btn-outline btn-xs"
            onClick={() => toast("Loading archived job detail…")}
          >
            <i className="fa-solid fa-eye"></i>
            View
          </button>

        </div>

      </div>

    </div>


    {/* =========================
        INTERVIEWS TAB
    ========================= */}
    <div id="tab-interviews" className={activeTab === "interviews" ? "" : "tab-hidden"}>

      <div className="schedule-action">

        <button
          className="btn btn-primary btn-sm"
          onClick={() => {
            window.location.href =
              "recruitment-interview-schedule.html";
          }}
        >
          <i className="fa-solid fa-calendar-plus"></i>
          Schedule Interview
        </button>

      </div>


      <div className="sec-block">

        <div className="sec-hd">

          <h4>
            <i className="fa-solid fa-calendar-check sec-heading-icon"></i>
            Interview Rounds
          </h4>

        </div>


        {/* ROUND 2 */}
        <div className="app-row">

          <div className="interview-date">

            <div className="interview-day">
              26
            </div>

            <div className="interview-month">
              Jun
            </div>

          </div>

          <div className="interview-divider amber"></div>

          <div className="interview-content">

            <div className="interview-title">
              Round 2 — HR Interview
            </div>

            <div className="interview-meta">
              JOB-2026-001 · Panel: Priya Sharma ·
              11:00 AM – 12:00 PM · Google Meet
            </div>

          </div>

          <span className="interview-status interview-status-scheduled">
            Scheduled · Today
          </span>

          <button
            className="btn btn-warn btn-xs"
            onClick={() => setFeedbackModal(true)}
          >
            <i className="fa-solid fa-star"></i>
            Feedback
          </button>

        </div>


        {/* ROUND 1 */}
        <div className="app-row">

          <div className="interview-date">

            <div className="interview-day default">
              8
            </div>

            <div className="interview-month">
              Jun
            </div>

          </div>

          <div className="interview-divider green"></div>

          <div className="interview-content">

            <div className="interview-title">
              Round 1 — Technical Screening
            </div>

            <div className="interview-meta">
              JOB-2026-001 · Panel: Rahul Dev ·
              10:00 AM – 11:00 AM · Zoom
            </div>

            <div className="interview-rating">

              <span className="rating-green">
                Technical 8/10
              </span>

              {" · "}

              <span className="rating-green">
                Comm. 9/10
              </span>

              {" · "}

              <span className="rating-green">
                Problem Solving 8/10
              </span>

            </div>

          </div>

          <span className="interview-status interview-status-cleared">
            Cleared
          </span>

          <button
            className="btn btn-outline btn-xs"
            onClick={() => setFeedbackModal(true)}
          >
            <i className="fa-solid fa-star"></i>
            View
          </button>

        </div>

      </div>

    </div>

  </div>

</div>
      </div>

      <div className={`modal-overlay ${addNoteModal ? "open" : ""}`} id="addNoteModal">
        <div className="modal-box">

          {/* Modal Header */}
          <div className="modal-head">

            <div className="modal-icon add-note-modal-icon">
              <i className="fa-solid fa-note-sticky"></i>
            </div>

            <div className="add-note-modal-content">
              <div className="modal-title">
                Add Note
              </div>

              <div className="modal-sub">
                Rahul Kumar
              </div>
            </div>

            <button
              className="modal-close-btn"
              onClick={() => setAddNoteModal(false)}
            >
              <i className="fa-solid fa-times"></i>
            </button>

          </div>

          {/* Modal Body */}
          <div className="modal-body">

            <div className="fg">

              <label>
                Note <span className="add-note-required">*</span>
              </label>

              <textarea
                className="og-textarea"
                rows="4"
                placeholder="Add internal note. Visible only to HR team with access."
              ></textarea>

            </div>

          </div>

          {/* Modal Footer */}
          <div className="modal-foot">

            <button
              className="btn btn-secondary btn-sm"
              onClick={() => setAddNoteModal(false)}
            >
              Cancel
            </button>

            <button
              className="btn btn-primary btn-sm"
              onClick={() => {
                setAddNoteModal(false);
                toast("Note added");
              }}
            >
              <i className="fa-solid fa-check"></i>
              Save
            </button>

          </div>

        </div>
      </div>

      <div className={`modal-overlay ${feedbackModal ? "open" : ""}`} id="feedbackModal">
  <div className="modal-box wide">

    <div className="modal-head">

      <div className="modal-icon feedback-modal-icon">
        <i className="fa-solid fa-star"></i>
      </div>

      <div className="feedback-modal-title-wrap">
        <div className="modal-title">Submit Feedback</div>
        <div className="modal-sub">
          Round 2 — HR Interview · Rahul Kumar
        </div>
      </div>

      <button
        className="modal-close-btn"
        onClick={() => setFeedbackModal(false)}
      >
        <i className="fa-solid fa-times"></i>
      </button>

    </div>

    <div className="modal-body">

      {/* Rating Section */}
      <div className="feedback-rating-grid">

        {/* Technical Skills */}
        <div>
          <div className="feedback-rating-title">
            Technical Skills
          </div>

          <div className="rating-buttons" id="r1">
            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((rating) => (
              <button
                key={rating}
                type="button"
                className="rating-btn"
              >
                {rating}
              </button>
            ))}
          </div>
        </div>

        {/* Communication */}
        <div>
          <div className="feedback-rating-title">
            Communication
          </div>

          <div className="rating-buttons" id="r2">
            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((rating) => (
              <button
                key={rating}
                type="button"
                className="rating-btn"
              >
                {rating}
              </button>
            ))}
          </div>
        </div>

        {/* Problem Solving */}
        <div>
          <div className="feedback-rating-title">
            Problem Solving
          </div>

          <div className="rating-buttons" id="r3">
            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((rating) => (
              <button
                key={rating}
                type="button"
                className="rating-btn"
              >
                {rating}
              </button>
            ))}
          </div>
        </div>

        {/* Culture Fit */}
        <div>
          <div className="feedback-rating-title">
            Culture Fit
          </div>

          <div className="rating-buttons" id="r4">
            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((rating) => (
              <button
                key={rating}
                type="button"
                className="rating-btn"
              >
                {rating}
              </button>
            ))}
          </div>
        </div>

      </div>

      {/* Overall Recommendation */}
      <div className="feedback-recommendation">

        <div className="feedback-recommendation-title">
          Overall Recommendation
        </div>

        <div className="recommendation-options">

          <label className="recommendation-option">
            <input
              type="radio"
              name="rec"
              className="recommendation-proceed"
            />
            <span className="recommendation-proceed-text">
              Proceed
            </span>
          </label>

          <label className="recommendation-option">
            <input
              type="radio"
              name="rec"
              className="recommendation-maybe"
            />
            <span className="recommendation-maybe-text">
              Maybe
            </span>
          </label>

          <label className="recommendation-option">
            <input
              type="radio"
              name="rec"
              className="recommendation-reject"
            />
            <span className="recommendation-reject-text">
              Reject
            </span>
          </label>

        </div>
      </div>

      {/* Comments */}
      <textarea
        className="og-textarea"
        rows="3"
        placeholder="Additional comments…"
      ></textarea>

    </div>

    {/* Footer */}
    <div className="modal-foot">

      <button
        className="btn btn-secondary btn-sm"
        onClick={() => setFeedbackModal(false)}
      >
        Cancel
      </button>

      <button
        className="btn btn-primary btn-sm"
        onClick={() => {
          setFeedbackModal(false);
          toast("Feedback submitted");
        }}
      >
        <i className="fa-solid fa-check"></i>
        Submit Feedback
      </button>

    </div>

  </div>
</div>

<div className={`modal-overlay ${createEmpModal ? "open" : ""}`} id="createEmpModal">
  <div className="modal-box">

    <div className="modal-head">

      <div className="modal-icon create-employee-modal-icon">
        <i className="fa-solid fa-user-check"></i>
      </div>

      <div className="create-employee-modal-title-wrap">
        <div className="modal-title">
          Create Employee Record
        </div>

        <div className="modal-sub">
          Rahul Kumar
        </div>
      </div>

      <button
        className="modal-close-btn"
        onClick={() => setCreateEmpModal(false)}
      >
        <i className="fa-solid fa-times"></i>
      </button>

    </div>

    <div className="modal-body">

      <p className="create-employee-description">
        Candidate data will be pre-filled in the employee form.
        Review and complete before saving.
      </p>

      <div className="fg">
        <label>
          Joining Date{" "}
          <span className="create-employee-required">*</span>
        </label>

        <input
          type="date"
          className="og-input"
        />
      </div>

      <div className="fg">
        <label>Department</label>

        <input
          className="og-input"
          value="Engineering"
          readOnly
        />
      </div>

      <div className="fg">
        <label>Designation</label>

        <input
          className="og-input"
          value="Senior Frontend Developer"
          readOnly
        />
      </div>

    </div>

    <div className="modal-foot">

      <button
        className="btn btn-secondary btn-sm"
        onClick={() => setCreateEmpModal(false)}
      >
        Cancel
      </button>

      <button
        className="btn btn-primary btn-sm create-employee-submit"
        onClick={() => {
          setCreateEmpModal(false);
          toast("Employee creation form opened with pre-filled data");
        }}
      >
        <i className="fa-solid fa-user-plus"></i>
        Create Employee
      </button>

    </div>

  </div>
</div>

<div className={`modal-overlay ${editModal ? "open" : ""}`} id="editModal">
  <div className="modal-box">

    <div className="modal-head">

      <div className="modal-icon edit-candidate-modal-icon">
        <i className="fa-solid fa-pen"></i>
      </div>

      <div className="edit-candidate-title-wrap">
        <div className="modal-title">
          Edit Candidate
        </div>
      </div>

      <button
        className="modal-close-btn"
        onClick={() => setEditModal(false)}
      >
        <i className="fa-solid fa-times"></i>
      </button>

    </div>

    <div className="modal-body">

      <div className="edit-candidate-grid">

        <div className="fg">
          <label>First Name</label>
          <input
            className="og-input"
            defaultValue="Rahul"
          />
        </div>

        <div className="fg">
          <label>Last Name</label>
          <input
            className="og-input"
            defaultValue="Kumar"
          />
        </div>

        <div className="fg">
          <label>Email</label>
          <input
            className="og-input"
            defaultValue="rahul.kumar@gmail.com"
          />
        </div>

        <div className="fg">
          <label>Phone</label>
          <input
            className="og-input"
            defaultValue="+91 99001 23456"
          />
        </div>

        <div className="fg">
          <label>Expected CTC</label>
          <input
            className="og-input"
            defaultValue="14–18 LPA"
          />
        </div>

        <div className="fg">
          <label>Notice Period</label>

          <select className="og-select" defaultValue="30 days">
            <option value="30 days">30 days</option>
            <option value="15 days">15 days</option>
            <option value="Immediate">Immediate</option>
            <option value="60 days">60 days</option>
          </select>
        </div>

      </div>

    </div>

    <div className="modal-foot">

      <button
        className="btn btn-secondary btn-sm"
        onClick={() => setEditModal(false)}
      >
        Cancel
      </button>

      <button
        className="btn btn-primary btn-sm"
        onClick={() => {
          setEditModal(false);
          toast("Candidate updated");
        }}
      >
        <i className="fa-solid fa-check"></i>
        Save Changes
      </button>

    </div>

  </div>
</div>
    </>
  )
}

export default RecruitmentCandidateProfile